<template>
  <div class="order-retry">
    <div class="orders-numbers-input">
      <vue-tags-input
        :key="reloadTags"
        v-model="orderNumber"
        :add-on-key="[13, ',', ';', ' ']"
        :separators="[',', ';', ' ']"
        :avoid-adding-duplicates="false"
        :placeholder="$t('admin.retry_placeholder')"
        v-on:tags-changed="updateOrderNumbers" />
      <backstage-button v-on:click="retry">
        {{ $t('admin.retry') }}
      </backstage-button>
    </div>
    <grid-retriable-orders />
  </div>
</template>
<script lang="ts">
import { OrdersService } from '@/services/orders.service';
import VueTagsInput from '@sipec/vue3-tags-input';
import { defineComponent } from 'vue';
import BackstageButton from '../../components/common/BackstageButton.vue';
import GridRetriableOrders from '../../components/orders/grid-order-retriable.vue';
// example, try to paste this
// SO123, SO234, SOSOSO; SO456 SOOOO

export default defineComponent({
  name: 'order-retry',
  components: {
    VueTagsInput,
    'grid-retriable-orders': GridRetriableOrders,
    BackstageButton,
  },
  data() {
    return {
      ordersService: new OrdersService(),
      orderNumberList: [] as { text: string }[],
      orderNumber: '',
      reloadTags: 0,
    };
  },
  methods: {
    updateOrderNumbers(newOrderNumberList: { text: string }[]) {
      this.orderNumberList = newOrderNumberList;
    },
    async retry() {
      const orderNumbers = this.orderNumberList.map((tag) => tag.text);
      const result = await this.ordersService.retryOrders(orderNumbers);

      this.$snotify.success(
        this.$t('admin.orders_correctly_set_to_be_retried').toString() +
          result.model.reduce((text: string, orderNumber: string) => (text += `${orderNumber}, `), ''),
      );
      this.reloadTags++;
    },
  },
});
</script>
<style lang="scss">
.order-retry {
  @include main-max-with;

  padding: 20px 10px 0;
  width: 100%;
  margin: 0 auto;

  .vue-tags-input {
    background-color: var(--primary-bg-color);
    border: 1px solid var(--border-color);
    color: var(--primary-text-input-color);
    max-width: initial;

    .ti-tag {
      height: 45px;
      box-sizing: content-box;
    }
  }

  .orders-numbers-input {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-bottom: 20px;

    .vue-tags-input {
      flex: 1;
      border: none;
      max-width: 100%;

      .ti-new-tag-input-wrapper input {
        height: 30px;
        background: transparent;
        color: #000;
      }

      .ti-tag {
        height: 30px;
      }

      .ti-content {
        margin-left: 10px;
      }

      .ti-actions {
        border-left: 1px solid;
        padding-left: 10px;
        padding-right: 5px;
        margin-left: 10px;

        .ti-icon-close:before {
          content: '\2715';
        }
      }
    }
  }
}
</style>
